import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const GET_CUSTOMER_MATCHES = gql`
  query GetCustomerMatches(
    $subcategoryId: String!
    $countryCode: String!
    $campaignId: String
    $visitorId: String!
    $answers: [AnswerInput]!
    $predefinedSupplierId: String
    $fallbackSupplierIds: [ID!]
    $mode: MatchingMode
    $withAiEnrichment: Boolean
    $withUsps: Boolean
    $subcategoryName: String
    $formId: String
    $testMode: Boolean
  ) {
    getCustomerMatches(
      subcategoryId: $subcategoryId
      countryCode: $countryCode
      campaignId: $campaignId
      visitorId: $visitorId
      answers: $answers
      withUsps: $withUsps
      predefinedSupplierId: $predefinedSupplierId
      fallbackSupplierIds: $fallbackSupplierIds
      mode: $mode
      withAiEnrichment: $withAiEnrichment
      subcategoryName: $subcategoryName
      formId: $formId
      testMode: $testMode
    ) {
      customerMatches {
        brandId
        brandRevisionId
        brandFilterValue
        brandLabel
        brandLogoUrl
        requiresLegalStatementAboveNav
        requiresSingleSupplierStatementWhenAlone
        supplierId
        usps
        ctaText
        matchLevel
        isExclusive
        isReseller
        subscriptionId
        matchScore
        matchReasons
      }
      matchLevel
      maximumMatches
      scoreSummary
    }
  }
`;

const getCustomerMatchesQuery = async (params) => {
  const { variables } = params;
  try {
    const response = await query({
      query: GET_CUSTOMER_MATCHES,
      variables,
    });

    return response.data.getCustomerMatches;
  } catch (error) {
    throw new Error(error);
  }
};

export default getCustomerMatchesQuery;
